/**
 * Each service's base URL, from the app config: apps/core/public/config.json
 * locally, and app-state's service-endpoints.yaml when deployed.
 */
interface Endpoints {
  paymentApiEndpoint?: string;
  userManagementEndpoint?: string;
  frontendConfigServiceEndpoint?: string;
  conduitGatewayEndpoint?: string;
}

let endpoints: Endpoints = {};

/**
 * Fills the endpoint getters from the app config. apps/core/src/index.js calls
 * it once, before the store starts the epics.
 */
export const configureEndpoints = (config: Endpoints): void => {
  endpoints = { ...config };
};

export const getPaymentApiEndpoint = (): string | undefined =>
  endpoints.paymentApiEndpoint;

export const getUserManagementEndpoint = (): string | undefined =>
  endpoints.userManagementEndpoint;

export const getFrontendConfigServiceEndpoint = (): string | undefined =>
  endpoints.frontendConfigServiceEndpoint;

export const getConduitGatewayEndpoint = (): string | undefined =>
  endpoints.conduitGatewayEndpoint;
